import { Button, ButtonProps, CircularProgress } from "@mui/material";
import React from "react";

export type Props = ButtonProps & {
  isFetching?: boolean;
};

export const LoadingButton = ({
  isFetching = false,
  disabled = false,
  children,
  ...rest
}: Props) => {
  return (
    <Button
      disabled={disabled || isFetching}
      type="submit"
      variant="primary"
      disableElevation
      startIcon={
        isFetching && (
          <CircularProgress
            color="inherit"
            size={20}
            data-testid="button-loading"
          />
        )
      }
      {...rest}
    >
      <span>{children}</span>
    </Button>
  );
};
